











import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component({
  name: 'tip'
})
export default class extends Vue {
  @Prop() private dataTable!:any
  @Prop() private listLoading!:boolean
}
